import React, {useEffect, useState} from "react"
import {Amplify, Auth} from "aws-amplify";
import awsconfig from "../aws-exports";
import {RootStore} from "../stores/RootStore";
import {MobxContestStore} from "../stores/MobxContestStore";
import awsConfig from "../aws-exports";
import {ApolloClient, ApolloLink, InMemoryCache} from "@apollo/client";
import {AUTH_TYPE, createAuthLink} from "aws-appsync-auth-link";
import {createSubscriptionHandshakeLink} from "aws-appsync-subscription-link";


Amplify.configure(awsconfig)

export const StoreContext = React.createContext<RootStore>(null)

export const Root = ({children}) => {

  const [rootStore, setRootStore] = useState<RootStore>(undefined)

  useEffect(() => {
    let mounted = true
    Auth.currentUserInfo().then(userInfo => {

      if (mounted) {
        const client = getApolloClient()
        MobxContestStore.createNew(client).then(contestStore => {
          setRootStore(new RootStore(client,  contestStore, userInfo.id, userInfo.username))
        })
      }
      mounted = false
    })

    return () => false
  }, [])

  return rootStore
    ? <StoreContext.Provider value={rootStore}>
      {children}</StoreContext.Provider>
    : <React.Fragment>{children}</React.Fragment>;
}

function getApolloClient() {
  const url = awsConfig.aws_appsync_graphqlEndpoint
  const region = awsConfig.aws_appsync_region

  const link = ApolloLink.from([
    createAuthLink({
      url, region, auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: () => Auth.currentSession().then(token => token.getAccessToken().getJwtToken())
      }
    }),
    createSubscriptionHandshakeLink({
      url, region, auth: {
        type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
        jwtToken: () => Auth.currentSession().then(token => token.getAccessToken().getJwtToken())
      }
    })
  ])

  return new ApolloClient({
    link,
    cache: new InMemoryCache()
  })
}
